import cn from 'classnames';
import { asks } from 'fp-ts/lib/Reader';
import * as React from 'react';
import { memo } from 'react';
import { Input } from 'reactstrap';
import dudeSvg from '../assets/images/dude.svg';
import css from './AuthorNameInput.module.scss';
export var AuthorNameInput = asks(function (ctx) {
    return memo(function (_a) {
        var value = _a.value, onChange = _a.onChange, _b = _a.hasError, hasError = _b === void 0 ? false : _b, _c = _a.theme, theme = _c === void 0 ? {} : _c;
        return (React.createElement("div", { className: cn(css.authorName, theme.container) },
            React.createElement("img", { alt: "Dude", src: ctx.resolveResource(dudeSvg) }),
            React.createElement(Input, { className: cn(css.authorNameInput, theme.input), value: value, placeholder: "Your name (optional)", onChange: function (e) { return onChange(e.target.value); } }),
            hasError && React.createElement("div", { className: cn(css.error, theme.error) }, "Please present yourself")));
    });
});
//# sourceMappingURL=AuthorNameInput.js.map